<script setup>
import draggable from 'vuedraggable';
import KanbanCard from './KanbanCard.vue';
import StageMenu from './StageMenu.vue';

const props = defineProps({
  stage: { type: Object, required: true },
  cards: { type: Array, required: true },
});
const emit = defineEmits(['move', 'card-click', 'add-card', 'edit-stage', 'delete-stage']);

function handleChange(event) {
  const added = event.added || event.moved;
  if (!added) return;
  const card = added.element;
  if (!card) return;
  emit('move', {
    cardId: card.id,
    stageId: props.stage.id,
    position: added.newIndex,
  });
}

const cardsProxy = {
  get: () => props.cards,
  set: () => {
    // mutation handled by parent via emit('move')
  },
};
</script>

<template>
  <section
    class="w-72 flex-shrink-0 flex flex-col bg-n-solid-1 rounded-lg border border-n-weak"
  >
    <header
      class="px-3 py-2 border-b border-n-weak flex items-center justify-between"
      :style="stage.color ? { borderTop: `3px solid ${stage.color}` } : {}"
    >
      <div class="flex items-center gap-2 min-w-0">
        <h3 class="text-sm font-medium text-n-slate-12 truncate">
          {{ stage.name }}
        </h3>
        <span class="text-xs text-n-slate-10 flex-shrink-0">{{
          cards.length
        }}</span>
      </div>
      <div class="flex items-center gap-1 flex-shrink-0">
        <span
          v-if="stage.wip_limit"
          class="text-[10px] uppercase tracking-wide"
          :class="
            stage.over_wip_limit
              ? 'text-red-600 font-semibold'
              : 'text-n-slate-10'
          "
        >
          {{ cards.length }}/{{ stage.wip_limit }}
        </span>
        <button
          class="size-5 grid place-content-center rounded hover:bg-n-alpha-1 text-n-slate-10 hover:text-n-brand"
          title="Adicionar card"
          @click="$emit('add-card', stage.id)"
        >
          <span class="i-lucide-plus size-3.5" />
        </button>
        <StageMenu
          :stage="stage"
          @edit="$emit('edit-stage', stage)"
          @delete="$emit('delete-stage', stage)"
        />
      </div>
    </header>

    <draggable
      :model-value="cards"
      :group="{ name: 'kanban', pull: true, put: true }"
      item-key="id"
      class="flex-1 overflow-y-auto p-2 space-y-2 min-h-[60px]"
      :animation="150"
      ghost-class="opacity-40"
      @change="handleChange"
    >
      <template #item="{ element }">
        <KanbanCard
          :card="element"
          @edit="$emit('card-click', element)"
        />
      </template>
    </draggable>
  </section>
</template>
